<template>
	<div class="modal fade overflow-hidden" :id="modalId" role="dialog" :class="{'force-bg': forceBg}" data-backdrop="static">
		<div class="modal-dialog modal-lg bani-modal">
			<div class="modal-content w-limit">
				<div class="modal-header">
					<div class="nav-btn kiri"></div>
					<h5 class="navbar-title text-center">{{ modalTitle }}</h5>
					<div class="nav-btn kanan tutup">
						<img src="../../../assets/img/x2.svg" @click="close">
					</div>
				</div>
				<div :class="{'modal-body': !noPadding}">
					<slot name="modal-body"></slot>
				</div>
				<div :class="{'modal-footer': !noPadding}">
					<slot name="modal-footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOSlotModal",
	props: {
		modalId: String,
		modalTitle: String,
		noPadding: Boolean,
		forceBg: Boolean,
		stackModal: {
			type: Boolean,
			default: false,
		}
	},
	methods: {
		close() {
			this.$emit("close")
		}
	},
	beforeDestroy() {
		$(".modal-backdrop").remove()
		$("body").removeClass("modal-open")
		// $(".modal-backdrop").fadeOut(300)
		// setTimeout(() => {
		// 	$("#" + this.modalId).modal("hide");
		// 	$(".modal-backdrop").remove()
		// }, 300)
	},
}
</script>

<style>
.force-bg {
	background: #00000099;
}
.modal-header {
    padding: 16px 20px;
}

.modal-body {
    padding: 0px 20px;
}
</style>